<template>
  <v-container class="">
    <datatable-approve-requests
      ref="datatable-approve-requests"
      title="Solicitudes de Aprobación"
    ></datatable-approve-requests>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import DatatableApproveRequests from "@/components/proyectos/lugarInstalacion/lugarSolicitudMaterial/approveRequests/DatatableApproveRequests.vue";
import { authMethods, authUsuarioComputed } from "@/state/helpers";
export default {
  components: { DatatableApproveRequests },
  methods: {
    ...authMethods,
    ...mapActions({
      getAllUsersActiveContract: "user/getAllUsersActiveContract",
      cleanRequestsMaterialsToApprove:
        "requestMaterial/cleanRequestsMaterialsToApprove",
    }),
    verifyApprovedParamAndShowToast() {
      let self = this;
      setTimeout(() => {
        const { approved, shopping_index } = self.$route.query;
        if (approved) {
          self.$swal.fire({
            icon: approved == "true" ? "success" : "error",
            title: "¡Excelente!",
            text: `Solicitud con código ${shopping_index} se ha ${
              approved == "true" ? "Aprobado" : "Rechazado"
            } correctamente`,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 8000,
            timerProgressBar: true,
          });
          self.$router.push({
            name: "requestMaterialsApprovals",
            query: {},
          });
        }
      }, 1000);
    },
  },
  mounted() {
    this.getAllUsersActiveContract({
      date: new Date().toISOString().split("T")[0],
    });
    this.verifyApprovedParamAndShowToast();
  },
  destroyed() {
    this.cleanRequestsMaterialsToApprove();
  },
  computed: {
    ...authUsuarioComputed,
  },
};
</script>

<style></style>